const filterPeriods = (type, labels, years, customDateRange) => {
  let startDate;
  let endDate;

  const formatDate = (date) => {
    return date.toISOString().split('T')[0]; // Returns the date in "YYYY-MM-DD"
  };
  if (type === 'months') {
    startDate = formatDate(new Date(`${years[0]}-01-01`));
    endDate = formatDate(new Date(`${years[0]}-12-31`));
  }

  if (type === 'quarters') {
    const date = new Date();
    const currentYear = date.getFullYear();
    const startMonth = labels[0] === 'I' ? 'Jan' : labels[0] === 'II' ? 'Apr' : labels[0] === 'III' ? 'Jul' : 'Oct';
    const getStartDate = new Date(`01-${startMonth}-${years ? years[0] : currentYear}`);
    startDate = formatDate(getStartDate);

    const lastQuarter = labels[labels.length - 1];
    const getEndDate = new Date(
      `01-${lastQuarter === 'IV' ? 'Dec' : lastQuarter === 'III' ? 'Sep' : lastQuarter === 'II' ? 'Jun' : 'Mar'}-${
        years ? years[years.length - 1] : currentYear
      }`,
    );
    getEndDate.setMonth(getEndDate.getMonth() + 1);
    getEndDate.setDate(getEndDate.getDate() - 1);
    endDate = formatDate(getEndDate);
  }

  if (type === 'years') {
    const getStartDate = new Date(`01-Jan-${labels[0]}`);
    startDate = formatDate(getStartDate);
    const getEndDate = new Date(`31-Dec-${labels[labels.length - 1]}`);
    startDate = formatDate(getEndDate);
  }

  if (type === 'custom') {
    const getStartDate = new Date(customDateRange.startDate);
    startDate = formatDate(getStartDate);
    const getEndDateDate = new Date(customDateRange.endDate);
    endDate = formatDate(getEndDateDate);
  }

  return {
    startDate,
    endDate,
  };
};

export default filterPeriods;
